module.exports = __webpack_public_path__ + "img/button-p4=hover.c393a013.png";